import React from "react";

const WORDS = [
  "AMAPIANO",
  "AFRO-TECH",
  "R&B",
  "HIP-HOP",
  "FILM SCORING",
  "ELECTRONIC-ORCHESTRAL",
];

const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="border-y border-gray-200 py-6 overflow-hidden">
      <div className="afr-marquee flex w-max items-center gap-8 whitespace-nowrap will-change-transform">
        {row.map((w, i) => (
          <div key={i} className="flex items-center gap-8">
            <span className="font-heading text-2xl sm:text-4xl font-semibold tracking-tight text-neutral-900">
              {w}
            </span>
            <span className="h-2 w-2 rounded-full bg-playing" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
